var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('app-k-v',{attrs:{"titulo":"CNPJ","md":4,"lg":3,"xl":2,"dado":_vm.$maskCpfCnpj(_vm.beneficiario.cnpj)}}),_c('app-k-v',{attrs:{"titulo":"Nome","md":4,"lg":3,"xl":2,"dado":_vm.beneficiario.nome}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h5',{staticClass:"heading-1"},[_c('span',[_vm._v("BENEFICIÁRIO")])])
}]

export { render, staticRenderFns }